import { Link } from "react-router-dom";

export const Field = ({ label, name, value, onChange, type = "text", required, placeholder, as = "input", rows = 4, options, testId }) => {
  const common = {
    id: name,
    name,
    value,
    onChange: (e) => onChange(name, e.target.value),
    required,
    placeholder,
    className: "input-line",
    "data-testid": testId || `field-${name}`,
  };
  return (
    <div>
      <label htmlFor={name} className="label-line">{label}{required && <span className="text-gold ml-1">*</span>}</label>
      {as === "textarea" ? (
        <textarea rows={rows} {...common} />
      ) : as === "select" ? (
        <select {...common}>
          <option value="">Seleziona</option>
          {options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      ) : (
        <input type={type} {...common} />
      )}
    </div>
  );
};

export const PrivacyCheck = ({ checked, onChange, testId = "field-privacy" }) => (
  <label className="flex items-start gap-3 cursor-pointer text-sm font-light text-ink/70">
    <input type="checkbox" data-testid={testId} checked={checked} onChange={(e) => onChange(e.target.checked)} required className="mt-1 h-4 w-4 accent-[#1F2326]" />
    <span>Ho letto l'<Link to="/privacy-policy" className="underline underline-offset-4 hover:text-gold">informativa privacy</Link> (artt. 13-14 GDPR) e acconsento al trattamento dei dati forniti per ricevere riscontro alla mia richiesta. Se fornisco dati relativi a terzi (es. proprietari), dichiaro di esserne autorizzato.</span>
  </label>
);

export const SuccessBox = ({ title = "Richiesta inviata", text, testId = "form-success" }) => (
  <div data-testid={testId} className="border border-sage/50 bg-white p-10 md:p-14">
    <div className="eyebrow !text-sage mb-4">Grazie</div>
    <h3 className="h-card">{title}</h3>
    <p className="lead mt-4">{text}</p>
  </div>
);
